import language from "#scripts/translation";

export const show404 = () => {
  if (window.serverdata.configMeta.aim.custom404 !== undefined && window.serverdata.configMeta.aim.custom404 !== "") {
    parent.location = window.serverdata.configMeta.aim.custom404;
  } else {
    const metaTag = document.createElement('meta');
    metaTag.name = "robots";
    metaTag.content = "noarchive";
    document.head.appendChild(metaTag);

    const _404Image = window.serverdata.configMeta.aim.custom404Image || "/images/404-kari.png";
    const temp = `
      <div class="row">
        <div class="col-sm-12 justify-content-center">
          <div class="article site404">
            <div ${_404Image !== null && _404Image !== "none" ? 'class="row' : ""} justify-content-lg-center">
            ${_404Image !== null && _404Image !== "none"
        ? `<div class="col-sm-4 p-0 p-sm-3"><img src="${_404Image}" alt="" class="site404__img"></div><div class="col-sm-8">`
        : '<div class="">'
      }
                <div class="site404__text">
                  <h1 class="404__title">${language("NO_PAGE")}</h1>
                  <p cass="404__intro">${language("NO_PAGE_INTRO")}</p>
                  <p class="404__actions">${language("NO_PAGE_ACTIONS")}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      `;

    return temp;
  }
};
